import { z } from 'zod';

export const PHONE_SCHEMA = z
  .string()
  .length(11, { message: 'Номер телефона должен содержать 11 цифр' });
